import useAsync from 'react-use/lib/useAsync';
import { httpClient } from '@alfa-bank/site-http-client';

import type { ICitiesResponse } from '../model/http';
import { citiesEndPoint } from '../config';

export function useCityByGeo(cityPath?: string) {
    const response = useAsync(async () => {
        if (!cityPath) return null;
        const {
            data: {
                data: [city],
            },
        } = await httpClient.get<ICitiesResponse>(citiesEndPoint, {
            'path.eq': cityPath,
        });

        return city;
    }, [cityPath]);

    return response.value ?? null;
}
